import React from 'react';
import { useAuth } from '../../context/AuthContext';
 
const Dashboard = () => {
  const { user } = useAuth();
  const fullName = `${user?.first_name} ${user?.last_name}`;
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="max-w-sm p-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 text-white">
      <div className="flex items-center gap-4 rounded-xl bg-gradient-to-r from-blue-50 to-indigo-50 p-6 shadow-sm">
        
        {/* Avatar */}
        <img
          src={user?.image?.path || '/assets/images/default-avatar.png'}
          alt={fullName}
          className="h-12 w-12 rounded-full border-2 border-white shadow"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/assets/images/default-avatar.png';
          }}
        />

        {/* Text */}
        <div>
          <h1 className="text-xl font-semibold text-gray-800">
            Welcome back,<br />
            <span className="text-blue-600">{fullName}</span> 👋
          </h1>
          <p className="mt-1 text-sm text-gray-600">
            Glad to see you
          </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Dashboard; 